export default "__VITE_ASSET__930f151e__"